export const electronicsBlog = {
    mobileUnder15: {
        "title": "Best mobiles under 15k",
        "subTitle": "",
        "image": "/assets/img/thumbnails/mobile-1.png",
        "url": "/top-laptops-under-15k",
        "date": "",
        "tags": [
            "Mobile"
        ],
        "categories": [
            "Electronics"
        ],
        "recommendations": "Mobile recommendations",
        "pageStructure": [
            {
                "component": "paragraphBoldItalic",
                "text": "We hope you likes the products we recommend! All of them were independently hand picked by our editors. Just so you know, TopMoneySaver may collect a share of sales or other compensation from the links on this page if you decide to shop from them."
            },
            {
                "component": "productList",
                "list": [
                    {
                        "name": "realme NARZO 70x 5G (Forest Green, 8GB RAM,128GB Storage)",
                        "price": "14,899 Rs",
                        "targetUrl": "https://amzn.to/3Cveogd",
                        "imgSrc": "https://m.media-amazon.com/images/I/71MI4QbQIvL._SL1500_.jpg",
                        "ratingValue": 90,
                        "disclaimer": true,
                        "description": {
                            "type": "list",
                            "list": [
                                {
                                    "title": "Camera",
                                    "text": "50MP AI Camera "
                                },
                                {
                                    "title": "Display",
                                    "text": "120Hz Ultra Smooth Display "
                                },
                                {
                                    "title": "Battery",
                                    "text": "5000mAh Massive Battery provide upto 26 days Standby or up to 35 hours Music.Monster 6000 mAh Battery"
                                },
                                {
                                    "title": "Memory, Storage",
                                    "text": "8GB RAM,128GB Storage"
                                },
                                {
                                    "title": "",
                                    "text": "**<< Grab Yours Today | https://amzn.to/3Cveogd>>**"
                                }
                            ],
                            "paragraphs": []
                        }
                    },
                    {
                        "name": "iQOO Z9 Lite 5G",
                        "price": "11,499 Rs",
                        "targetUrl": "https://amzn.to/4hreDrK",
                        "imgSrc": "https://m.media-amazon.com/images/I/410W-fBOP2L._SX300_SY300_QL70_FMwebp_.jpg",
                        "ratingValue": 90,
                        "disclaimer": true,
                        "description": {
                            "type": "list",
                            "list": [
                                {
                                    "title": "Camera",
                                    "text": "50MP Sony AI Camera |"
                                },
                                {
                                    "title": "Display",
                                    "text": "Capture sharp and vibrant images with the 50MP Sony AI Camera, ensuring that every vivid and radiant moment is perfectly framed within your camera wit"
                                },
                                {
                                    "title": "Battery",
                                    "text": "5000 mAh lithium polymer battery"
                                },
                                {
                                    "title": "Memory, Storage & SIM",
                                    "text": "6GB RAM, 128GB Storage and Dual Sim 5G capability."
                                },
                                {
                                    "title": "",
                                    "text": "**<< Own It Now | https://amzn.to/4hreDrK>>**"
                                }
                            ],
                            "paragraphs": []
                        }
                    },
                    {
                        "name": "Redmi 13 5G, Orchid Pink, 8GB+128GB",
                        "price": "13,749 Rs",
                        "targetUrl": "https://amzn.to/4aXw0hu",
                        "imgSrc": "https://m.media-amazon.com/images/I/81Q9jpYOFdL._SX679_.jpg",
                        "ratingValue": 90,
                        "disclaimer": true,
                        "description": {
                            "type": "list",
                            "list": [
                                {
                                    "title": "Camera",
                                    "text": "108MP Pro Grade Camera"
                                },
                                {
                                    "title": "Display",
                                    "text": "6.79inch Largest Display in Segment"
                                },
                                {
                                    "title": "Battery",
                                    "text": "1 Lithium Polymer batteries required. (included)"
                                },
                                {
                                    "title": "Memory, Storag",
                                    "text": " Orchid Pink, 8GB+128GB "
                                },
                                {
                                    "title": "Operating system",
                                    "text": "Latest Android v12.0, One UI 4 operating system"
                                },
                                {
                                    "title": "",
                                    "text": "**<< Best Price Here! | https://amzn.to/4aXw0hu>>**"
                                }
                            ],
                            "paragraphs": []
                        }
                    },
                    {
                        "name": "Samsung Galaxy M15 5G Prime Edition (Celestial Blue,8GB RAM,128GB Storage)",
                        "price": "13,499Rs",
                        "targetUrl": "https://amzn.to/4jLKODN",
                        "imgSrc": "https://m.media-amazon.com/images/I/81LJaRu0cZL._SX679_.jpg",
                        "ratingValue": 100,
                        "disclaimer": true,
                        "description": {
                            "type": "list",
                            "list": [
                                {
                                    "title": "Camera",
                                    "text": "50 MP wide angle camera with 13 selfie camera ,5 ultra wide camera,2 macro camera"
                                },
                                {
                                    "title": "Display",
                                    "text": "6.39 Centimeters (6.5Inch) Super AMOLED Display with 19.5:9 Aspect Ratio, FHD+ Resolution with 1080 x 2340 Pixels , 399 PPI with 16M Colors and 90Hz Refresh Rate"
                                },
                                {
                                    "title": "Battery",
                                    "text": "Get a massive 6000mAh Lithium-ion Battery (Non-Removable) with C-Type Super Fast Charging (25W Charging Support)"
                                },
                                {
                                    "title": "Memory, Storage",
                                    "text": "8 GB RAM +128 GB"
                                },
                                {
                                    "title": "",
                                    "text": "**<< Upgrade Your Gear | https://amzn.to/4jLKODN>>**"
                                }
                            ],
                            "paragraphs": []
                        }
                    },
                    {
                        "name": "POCO X6 Neo 5G (Martian Orange, 8GB RAM, 128GB Storage)",
                        "price": "11,999Rs",
                        "targetUrl": "https://amzn.to/4gyLh9J",
                        "imgSrc": "https://m.media-amazon.com/images/I/717kT9HNtOL._SY679_.jpg",
                        "ratingValue": 100,
                        "disclaimer": true,
                        "description": {
                            "type": "list",
                            "list": [
                                {
                                    "title": "Camera",
                                    "text": "108MP + 2MP Rear Camera & 16MP Front Camera"
                                },
                                {
                                    "title": "Display",
                                    "text": "6.67 FHD+ AMOLED (1080x2400) , Screen-to-Body Ratio: 93.30% Ultra-narrow bezels Display with 120Hz"
                                },
                                {
                                    "title": "Battery",
                                    "text": "5000 mAh Battery + 33W Fast Charging"
                                },
                                {
                                    "title": "Memory, Storage",
                                    "text": "8GB RAM | 128GB UFS 2.2 | Dual SIM (nano+nano) 5G"
                                },
                                {
                                    "title": "",
                                    "text": "**<< Get the Best Deal | https://amzn.to/4gyLh9J>>**"
                                }
                            ],
                            "paragraphs": []
                        }
                    }
                ]
            }
        ]
    },
    mobileUnder30: {
        "title": "Best mobiles under 30k",
        "subTitle": "",
        "image": "/assets/img/thumbnails/mobile-1.png",
        "url": "/top-laptops-under-30k",
        "date": "",
        "tags": [
            "Mobile"
        ],
        "categories": [
            "Electronics"
        ],
        "recommendations": "Mobile recommendations",
        "pageStructure": [
            {
                "component": "paragraphBoldItalic",
                "text": "We hope you likes the products we recommend! All of them were independently hand picked by our editors. Just so you know, TopMoneySaver may collect a share of sales or other compensation from the links on this page if you decide to shop from them."
            },
            {
                "component": "productList",
                "list": [
                    {
                        "name": "OnePlus Nord 4 5G (Mercurial Silver, 8GB RAM, 256GB Storage)",
                        "price": "29,998 Rs",
                        "targetUrl": "https://amzn.to/4hotNxL",
                        "imgSrc": "https://m.media-amazon.com/images/I/61JOYUJbhcL._SX679_.jpg",
                        "ratingValue": 100,
                        "disclaimer": true,
                        "description": {
                            "type": "list",
                            "list": [
                                {
                                    "title": "Camera",
                                    "text": "50 MP Rear camera,8MP Ultra-wide and 16MP Front camera"
                                },
                                {
                                    "title": "Display",
                                    "text": "120 hz OLED display "
                                },
                                {
                                    "title": "Battery",
                                    "text": "5500mAh Battery: Stay powered throughout your day with a massive 5500mAh battery."
                                },
                                {
                                    "title": "Memory, Storage",
                                    "text": "OnePlus Nord 4 8+128GB variant comes with UFS3.1 storage, whereas the 8+256GB & 12+256GB variant comes with UFS4.0 storage"
                                }
                            ],
                            "paragraphs": []
                        }
                    },
                    {
                        "name": "iQOO Z9s Pro 5G (Flamboyant Orange, 8GB RAM, 256GB Storage)",
                        "price": "24,999 Rs",
                        "targetUrl": "https://amzn.to/4hIAWsA",
                        "imgSrc": "https://m.media-amazon.com/images/I/711ZTkL0l8L._SL1200_.jpg",
                        "ratingValue": 90,
                        "disclaimer": true,
                        "description": {
                            "type": "list",
                            "list": [
                                {
                                    "title": "Camera",
                                    "text": "50MP OIS Main Camera, 8MP Wide Angle"
                                },
                                {
                                    "title": "Display",
                                    "text": "120Hz E4 AMOLED Display | 1300nits Peak Brightness | 6000000:1 Contrast Ratio | SGS Eye Care Certificate | HDR 10+ | Netflix HDR"
                                },
                                {
                                    "title": "Battery",
                                    "text": "5500mAh Battery."
                                },
                                {
                                    "title": "Memory, Storage & Processor",
                                    "text": "8GB RAM, 256GB Storage,PROCESSOR : Powered by Snapdragon 7 Gen 3 "
                                }
                            ],
                            "paragraphs": []
                        }
                    },
                    {
                        "name": "Samsung Galaxy A35 5G (Awesome Lilac, 8GB RAM, 128GB Storage) | Premium Glass Back ",
                        "price": "25,999 Rs",
                        "targetUrl": "https://amzn.to/414g5KL",
                        "imgSrc": "https://m.media-amazon.com/images/I/71picrEy4YL._SX679_.jpg",
                        "ratingValue": 91,
                        "disclaimer": true,
                        "description": {
                            "type": "list",
                            "list": [
                                {
                                    "title": "Camera",
                                    "text": " Nightography | Super HDR Video | 50MP (F1.8) Main Wide Angle Camera + 8MP (F2.2) Ultra Wide Camera + 5MP (F2.4) Macro Camera | 13MP (F2.2) Front Camera | Video Maximum Resolution of Ultra HD 4K (3840 x 2160) @30fps"
                                },
                                {
                                    "title": "Display",
                                    "text": "16.83 Centimeters (6.6Inch) Super AMOLED Display with 19.5:9 Aspect Ratio, FHD+ Resolution with 2340 x 1080 Pixels , 389 PPI with 16M Colors and 120Hz Refresh Rate, Corning Gorilla Glass Victus+ "
                                },
                                {
                                    "title": "Battery",
                                    "text": "Get a massive 5000mAh Lithium-ion Battery (Non-Removable) with C-Type Super Fast Charging (25W Charging Support)"
                                },
                                {
                                    "title": "Memory, Storag",
                                    "text": " 8GB RAM, 128GB Storage"
                                },
                                {
                                    "title": "Processor & Operating system",
                                    "text": "Latest Android 14 Operating System having One UI 6.1 platform with Samsung Exynos 1380 Processor | 2.4GHz, 2GHz 5nm Octa-Core Processor"
                                }
                            ],
                            "paragraphs": []
                        }
                    },
                    {
                        "name": "Motorola Edge 50 Fusion 5G",
                        "price": "23,840 Rs",
                        "targetUrl": "https://amzn.to/3WPREOB",
                        "imgSrc": "https://m.media-amazon.com/images/I/71XZP2Hm+5L._SX522_.jpg",
                        "ratingValue": 90,
                        "disclaimer": true,
                        "description": {
                            "type": "list",
                            "list": [
                                {
                                    "title": "Camera",
                                    "text": "50MP Ultra pixel with OIS, 13MP Ultra wide + Micro and 32MP Selfie camera 4k 30fps video recording"
                                },
                                {
                                    "title": "Display",
                                    "text": "144Hz 6.7Inch pOLED Curved display with Gorila Class 5 protection"
                                },
                                {
                                    "title": "Battery",
                                    "text": "The massive 5000mAh battery"
                                },
                                {
                                    "title": "Memory, Storage & Performance",
                                    "text": "The Snapdragon processor with 2.2 GHz CPU speed. Combined with 12GB RAM and 256GB storage"
                                }
                            ],
                            "paragraphs": []
                        }
                    },
                    {
                        "name": "Nothing Phone (2a) 5G",
                        "price": "23,999 Rs",
                        "targetUrl": "https://amzn.to/3CRogRj",
                        "imgSrc": "https://m.media-amazon.com/images/I/4172-I2V+AL._SY679_.jpg",
                        "ratingValue": 91,
                        "disclaimer": true,
                        "description": {
                            "type": "list",
                            "list": [
                                {
                                    "title": "Camera",
                                    "text": "50MP Main Camera, 32MP Front (Selfie) Camera"
                                },
                                {
                                    "title": "Display",
                                    "text": " 6.7 Inches; 120 Hz AMOLED Display with Corning Gorilla Glass 5; Resolution: 1080x2412 pixels (FHD+)"
                                },
                                {
                                    "title": "Battery",
                                    "text": "5000 mAh withfast charging"
                                },
                                {
                                    "title": "Memory, Storage",
                                    "text": "128GB RAM, 256GB Storage"
                                }
                            ],
                            "paragraphs": []
                        }
                    }
                ]
            }
        ]
    },
    bestLaptops: {
        "title": "Best laptops in 2022",
        "subTitle": "",
        "image": "/assets/img/thumbnails/laptop-1.png",
        "url": "/best-laptops-in-2022",
        "date": "",
        "tags": [
            "Laptop"
        ],
        "categories": [
            "Electronics"
        ],
        "recommendations": "Laptop recommendations",
        "pageStructure": [
            {
                "component": "paragraphBoldItalic",
                "text": "We hope you likes the products we recommend! All of them were independently hand picked by our editors. Just so you know, TopMoneySaver may collect a share of sales or other compensation from the links on this page if you decide to shop from them."
            },
            {
                "component": "paragraphBoldItalic",
                "text": "How we do our research?"
            },
            {
                "component": "paragraph",
                "text": "We consider each laptop’s features such as the display, processor, memory and storage. We also consider the design and durability of the device."
            },
            {
                "component": "paragraphBoldItalic",
                "text": "Things to look for while buying - "
            },
            {
                "component": "paragraph",
                "text": "Before purchasing a laptop, you need to consider things like the display, the processor and whether the storage offered is enough or not. You should also consider the battery life of the laptop."
            },
            {
                "component": "productList",
                "list": [
                    {
                        "name": "Dell Vostro 15 3520",
                        "price": "45,490 Rs",
                        "targetUrl": "https://amzn.to/4hOfUZx",
                        "imgSrc": "https://m.media-amazon.com/images/I/51Rdb1PIcZL._SX679_.jpg",
                        "ratingValue": 95,
                        "disclaimer": true,
                        "description": {
                            "type": "list",
                            "list": [
                                {
                                    "title": "Processor",
                                    "text": "Power of 10 cores and 12 threads with the 12th Gen Intel Core i5-1235U processor"
                                },
                                {
                                    "title": "Screen Size",
                                    "text": "The 15.6-inch FHD display with 1920x1080 resolution"
                                },
                                {
                                    "title": "Memory, Storage",
                                    "text": "8 GB RAM and 512 GB SSD, ensuring you can work efficiently without any lag with this i5 Laptop"
                                },
                                {
                                    "title": "Operating System",
                                    "text": "Windows 11 Home"
                                }
                            ],
                            "paragraphs": []
                        }
                    },
                    {
                        "name": "HP 15S AMD Ryzen 5000",
                        "price": "41,690 Rs",
                        "targetUrl": "https://amzn.to/4jIybtf",
                        "imgSrc": "https://m.media-amazon.com/images/I/71phX67q6zL._SX679_.jpg",
                        "ratingValue": 94,
                        "disclaimer": true,
                        "description": {
                            "type": "list",
                            "list": [
                                {
                                    "title": "Processor",
                                    "text": "Harness efficient multitasking with the AMD Ryzen 5 5500U processor, boasting 12 threads and an 8MB L3 cache"
                                },
                                {
                                    "title": "Screen Size",
                                    "text": "The 15.6-inch, FHD, 250-nit, anti-glare, and micro-edge display"
                                },
                                {
                                    "title": "Memory, Storage",
                                    "text": "16GB DDR4 RAM and a high-speed 512GB PCIe NVMe M.2 SSD"
                                },
                                {
                                    "title": "Operating System",
                                    "text": "Windows 11 and MS Office 2021"
                                }
                            ],
                            "paragraphs": []
                        }
                    },
                    {
                        "name": "Lenovo IdeaPad Slim 3",
                        "price": "38,190 Rs",
                        "targetUrl": "https://amzn.to/42M7SMr",
                        "imgSrc": "https://m.media-amazon.com/images/I/61q6x-ll5FL._SX679_.jpg",
                        "ratingValue": 91,
                        "disclaimer": true,
                        "description": {
                            "type": "list",
                            "list": [
                                {
                                    "title": "Processor",
                                    "text": "AMD Ryzen 5 5500U | Speed: 2.1 GHz (Base) - 4.0 GHz (Max) | 6 Cores | 12 Threads | 3MB L2 / 8MB L3 Cache"
                                },
                                {
                                    "title": "Screen Size",
                                    "text": "5.6inch FHD (1920x1080) | TN Technology | 250Nits Brightness Anti Glare"
                                },
                                {
                                    "title": "Memory, Storage",
                                    "text": "8GB RAM DDR4-3200, Upgradable Up to 12GB | 512GB SSD"
                                },
                                {
                                    "title": "Operating System",
                                    "text": "Windows 11 Home 64 | Office Home and Student 2021 "
                                }
                            ],
                            "paragraphs": []
                        }
                    },
                    {
                        "name": "ASUS Vivobook 15",
                        "price": "46,990 Rs",
                        "targetUrl": "https://amzn.to/3Qa8hB2",
                        "imgSrc": "https://m.media-amazon.com/images/I/71DYiVtpLhL._SX679_.jpg",
                        "ratingValue": 90,
                        "disclaimer": true,
                        "description": {
                            "type": "list",
                            "list": [
                                {
                                    "title": "Processor",
                                    "text": "Intel Celeron N4020 Processor 1.1 GHz Base speed (4MB Cache, up to 2.8 GHz Max Turbo Speed, 2 cores)"
                                },
                                {
                                    "title": "Screen Size",
                                    "text": "15.6-inch (35.56cm), FHD (1920 x 1080) 16:9 aspect ratio, LED Backlit, 60Hz refresh rate, 220nits, 45% NTSC color gamut, Non-touch screen,;Graphics: Integrated Intel UHD Graphics"
                                },
                                {
                                    "title": "Memory, Storage",
                                    "text": "8GB (4GB DDR4 on board + 4GB SO-DIMM) DDR4 | Storage: 512GB M.2 NVMe PCIe 3.0 SSD"
                                },
                                {
                                    "title": "Operating System",
                                    "text": "Pre-loaded Windows 11 Home with lifetime validity | Software Included: Pre-Installed Office Home and Student 2021"
                                }
                            ],
                            "paragraphs": []
                        }
                    },
                    {
                        "name": "Acer Aspire 3 14",
                        "price": "40,390 Rs",
                        "targetUrl": "https://amzn.to/41ad2B2",
                        "imgSrc": "https://m.media-amazon.com/images/I/61pi8NonKjL._SX679_.jpg",
                        "ratingValue": 88,
                        "disclaimer": true,
                        "description": {
                            "type": "list",
                            "list": [
                                {
                                    "title": "Processor",
                                    "text": "Intel Core i3 8-core N305 Processor with Intel UHD Graphics"
                                },
                                {
                                    "title": "Screen Size",
                                    "text": "14.0inch FHD 1920 x 1080, high-brightness Acer ComfyView LED-backlit TFT LCD, 16:9 aspect ratio,Ultra-slim design, Mercury free, environment friendly"
                                },
                                {
                                    "title": "Memory, Storage",
                                    "text": "512 GB SSD, PCIe Gen3, 8 Gb/s up to 4 lanes"
                                },
                                {
                                    "title": "Operating System",
                                    "text": "Pre-loaded Windows 11 Home| Software Included: Pre-Installed Office Home"
                                }
                            ],
                            "paragraphs": []
                        }
                    }
                ]
            }
        ]
    },
    bestLaptopsForStudents: {
        "title": "Best laptops for students in India",
        "subTitle": "",
        "image": "/assets/img/thumbnails/laptop-1.png",
        "url": "/best-laptop-for-students-in-india",
        "date": "",
        "tags": [
            "Laptop"
        ],
        "categories": [
            "Electronics"
        ],
        "recommendations": "Laptop recommendations",
        "pageStructure": [
            {
                "component": "paragraphBoldItalic",
                "text": "Are you looking for the best laptops for engineering students in India? After doing some extensive research we have listed down the best laptops for our future engineers. Keep Reading!"
            },
            {
                "component": "paragraphBoldItalic",
                "text": "Our list covers top quality laptops for computer science engineering (cse), civil engineering, mechanical engineering, or electrical engineering students to work on the project with ease."
            },
            {
                "component": "paragraph",
                "text": "A good quality laptop gives you a boost in your productivity, improves performance, as well as benefits with project management and running complex software. This guide is perfect for students who are planning to get a laptop after the admission to an engineering college or want to work with various engineering projects while pursuing an engineering degree. We’ll show you the top options available and explain how to find the best laptop for engineering students with frequently asked questions."
            },
            {
                "component": "productList",
                "list": [
                    {
                        "name": "Dell [Smartchoice] Windows 11 Home",
                        "price": "32,990 Rs",
                        "targetUrl": "https://amzn.to/3Q8B9cL",
                        "imgSrc": "https://m.media-amazon.com/images/I/61-Y-eWXqtL._SX679_.jpg",
                        "ratingValue": 96,
                        "disclaimer": true,
                        "description": {
                            "type": "list",
                            "list": [
                                {
                                    "title": "Processor",
                                    "text": "Intel Core i3-1215U 12th Generation (up to 4.40 GHz, 10MB 6 Cores)"
                                },
                                {
                                    "title": "Screen Size",
                                    "text": "39.62 centimetres FHD resolution 1920 x 1080 pixels"
                                },
                                {
                                    "title": "Memory & Storage",
                                    "text": "8 GB, 1 x 8 GB, DDR4, 2666 MHz, (2 DIMM Slots, Expandable up to 16GB) & 512GB SSD"
                                },
                                {
                                    "title": "Operating System",
                                    "text": "Pre-Loaded Windows 11 Home with Lifetime Validity | MS Office Home and Student 2021 with lifetime validity"
                                }
                            ],
                            "paragraphs": []
                        }
                    },
                    {
                        "name": "HP 15 Core i3",
                        "price": "35,650 Rs",
                        "targetUrl": "https://amzn.to/4aNPWDn",
                        "imgSrc": "https://m.media-amazon.com/images/I/61GyMa43yKL._SX679_.jpg",
                        "ratingValue": 92,
                        "disclaimer": true,
                        "description": {
                            "type": "list",
                            "list": [
                                {
                                    "title": "Processor",
                                    "text": "Intel ‎Core i3 (‎4.4 GHz with 6-core 12th Gen Intel Core i3-1215U)"
                                },
                                {
                                    "title": "Display",
                                    "text": "39.6cm, FHD, micro-edge,anti-glare |Graphics: Intel UHD Graphics"
                                },
                                {
                                    "title": "Memory & Storage",
                                    "text": " 8GB DDR4 RAM, 512GB PCIe NVMe SSD"
                                },
                                {
                                    "title": "Operating System",
                                    "text": "Windows 11 Home"
                                }
                            ],
                            "paragraphs": []
                        }
                    },
                    {
                        "name": "Lenovo IdeaPad Slim",
                        "price": "24,400 Rs",
                        "targetUrl": "https://amzn.to/4gwfeH9",
                        "imgSrc": "https://m.media-amazon.com/images/I/71g5WSGgHDL._SX679_.jpg",
                        "ratingValue": 90,
                        "disclaimer": true,
                        "description": {
                            "type": "list",
                            "list": [
                                {
                                    "title": "Processor",
                                    "text": "Intel CeleronN4020 | Speed: 1.1 GHz (Base) - 2.8 GHz (Max) | 2 Cores | 2 Threads | 4MB Cache"
                                },
                                {
                                    "title": "Display",
                                    "text": "39cm FHD (1366x768) | TN | 220Nits Brightness | Anti Glare"
                                },
                                {
                                    "title": "Graphics",
                                    "text": "Integrated Intel UHD Graphics 600 | Memory: 8GB DDR4-2400 | Storage: 512GB SSD NVMe"
                                },
                                {
                                    "title": "Operating System",
                                    "text": "Windows 11 Home Single Language, English | Office Home & Student 2021"
                                }
                            ],
                            "paragraphs": []
                        }
                    },
                    {
                        "name": "Acer Aspire Lite AMD Ryzen 5-5625U",
                        "price": "33,490 Rs",
                        "targetUrl": "https://amzn.to/40S2bu4",
                        "imgSrc": "https://m.media-amazon.com/images/I/61fDHkQ6MqL._SX679_.jpg",
                        "ratingValue": 88,
                        "disclaimer": true,
                        "description": {
                            "type": "list",
                            "list": [
                                {
                                    "title": "Processor",
                                    "text": "AMD Ryzen 5-5625U, Hexa-Core Processor with AMD Radeon Graphics"
                                },
                                {
                                    "title": "Screen Size",
                                    "text": "39.62 cm (15.6inch) Full HD Display | Anti-Glare"
                                },
                                {
                                    "title": "Memory and Storage",
                                    "text": "RAM - 16 GB of Dual-channel DDR4, 2 SODIMM sockets; Storage - 512 GB SSD NVMe solid-state drive storage (expandable up to 1TB)"
                                },
                                {
                                    "title": "Operating System",
                                    "text": "Pre-Loaded Windows 11 Home"
                                }
                            ],
                            "paragraphs": []
                        }
                    },
                    {
                        "name": "ASUS Vivobook Go 15",
                        "price": "40,990 Rs",
                        "targetUrl": "https://amzn.to/4hpe1Tm",
                        "imgSrc": "https://m.media-amazon.com/images/I/6140Vb9ScyL._SX679_.jpg",
                        "ratingValue": 85,
                        "disclaimer": true,
                        "description": {
                            "type": "list",
                            "list": [
                                {
                                    "title": "Processor",
                                    "text": "AMD Ryzen 5 7520U Mobile Processor (4-core/8-thread, 4MB cache, up to 4.3 GHz max boost) Designed for seamless productivity"
                                },
                                {
                                    "title": "Screen Size",
                                    "text": "15.6-inch (39.62 cm) FHD (1920 x 1080) 16:9 aspect ratio, 60Hz refresh rate, 45% NTSC color gamu"
                                },
                                {
                                    "title": "Memory & Storage",
                                    "text": "16GB DDR5 on board with | Storage: 512GB M.2 NVMe PCIe 3.0 SSD"
                                },
                                {
                                    "title": "Operating System",
                                    "text": "Pre-loaded Windows 11 Home | Office 2021"
                                }
                            ],
                            "paragraphs": []
                        }
                    }
                ]
            }
        ]
    },
    bestGamingLaptops: {
        "title": "Best Gaming Laptops In India",
        "subTitle": "",
        "image": "/assets/img/thumbnails/laptop-1.png",
        "url": "/best-gaming-laptops-in-india",
        "date": "",
        "tags": [
            "Laptop"
        ],
        "categories": [
            "Electronics"
        ],
        "recommendations": "Laptop recommendations",
        "pageStructure": [
            {
                "component": "paragraphBoldItalic",
                "text": "Are you looking for the best laptops for gaming in India? After doing some extensive research we have listed down the best laptops for our gamers. Keep Reading!"
            },
            {
                "component": "paragraph",
                "text": "A good quality laptop gives you a boost in your entertaintment, improves performance. This guide is perfect for those who are planning buy gaming laptop."
            },
            {
                "component": "productList",
                "list": [
                    {
                        "name": "ASUS TUF Gaming A15",
                        "price": "60,990 Rs",
                        "targetUrl": "https://amzn.to/42M6o4P",
                        "imgSrc": "https://m.media-amazon.com/images/I/61nTNphSBvL._SX679_.jpg",
                        "ratingValue": 96,
                        "disclaimer": true,
                        "description": {
                            "type": "list",
                            "list": [
                                {
                                    "title": "Processor",
                                    "text": "AMD Ryzen 7 7435HS Mobile Processor 3.1GHz (20MB Cache, up to 4.5 GHz, 8 cores, 16 Threads) delivers fast and responsive performance for demanding tasks such as gaming, content creation, and multitasking"
                                },
                                {
                                    "title": "Screen Size",
                                    "text": "15.6” FHD (1920 x 1080) 16:9, 144Hz, 250 nits Brightness, Anti-Glare Display, Display output : 1x HDMI 2.1 TMDS, Keyboard : Backlit Chiclet Keyboard 1-Zone RGB"
                                },
                                {
                                    "title": "Memory & Storage",
                                    "text": "512GB PCIe 4.0 NVMe M.2 SSD | Memory : 16GB DDR5-5600 MHz Support Up to 32 GB Expandable 2x DDR5 SO-DIMM slots"
                                },
                                {
                                    "title": "Operating System",
                                    "text": "Windows 11 | NVIDIA Geforce RTX 3050"
                                }
                            ],
                            "paragraphs": []
                        }
                    },
                    {
                        "name": "HP Victus",
                        "price": "89,999 Rs",
                        "targetUrl": "https://amzn.to/3CwXfmh",
                        "imgSrc": "https://m.media-amazon.com/images/I/71AgpCmmoHL._SX679_.jpg",
                        "ratingValue": 92,
                        "disclaimer": true,
                        "description": {
                            "type": "list",
                            "list": [
                                {
                                    "title": "Processor",
                                    "text": "10-core 13th Gen Intel Core i7-13620H With 24MB L3 cache and 16 threads, experience unparalleled speed and efficiency"
                                },
                                {
                                    "title": "Display",
                                    "text": "15.6” FHD display with a micro-edge bezel, delivering high-quality visuals with a rapid 144Hz refresh rate and 9ms response time"
                                },
                                {
                                    "title": "Memory & Storage",
                                    "text": "16GB DDR4 RAM and 1TB PCIe Gen4 NVMe SSD ensure a lag-free gaming experience with quick load times and smooth in-game transitions"
                                },
                                {
                                    "title": "Operating System",
                                    "text": "Win11, Office21 | 6GB NVIDIA RTX 4050"
                                }
                            ],
                            "paragraphs": []
                        }
                    },
                    {
                        "name": "Lenovo LOQ 2024 AMD Ryzen 7 7435HS",
                        "price": "82,690 Rs",
                        "targetUrl": "https://amzn.to/4hQaAF2",
                        "imgSrc": "https://m.media-amazon.com/images/I/616fX5Yh00L._SX679_.jpg",
                        "ratingValue": 90,
                        "disclaimer": true,
                        "description": {
                            "type": "list",
                            "list": [
                                {
                                    "title": "Processor",
                                    "text": "AMD Ryzen 7 7435HS | Speed: 3.1GHz (Base) - 4.5GHz (Max) | 8 Cores | 16 Threads | 16MB Cache"
                                },
                                {
                                    "title": "Display",
                                    "text": "15.6” FHD (1920x1080) IPS Technology | 144 Hz Refresh Rate | 100pct. sRGB |Brightness: 300Nits Anti-glare"
                                },
                                {
                                    "title": "Memory & Storage",
                                    "text": "2x12GB SO-DIMM DDR5-4800, Max Memory :-Up to 32GB DDR5-4800 | Storage: 512GB SSD M.2 2242 PCIe 4.0x4 NVMe"
                                },
                                {
                                    "title": "Operating System",
                                    "text": "Windows 11/Office Home 2024 | NVIDIA GeForce RTX 4050 6GB GDDR6, Boost Clock 2370MHz, TGP 105W | G-Sync "
                                }
                            ],
                            "paragraphs": []
                        }
                    },
                    {
                        "name": "MSI Cyborg 15",
                        "price": "74,490 Rs",
                        "targetUrl": "https://amzn.to/3QuAOl7",
                        "imgSrc": "https://m.media-amazon.com/images/I/61UQ4m-H+yL._SX679_.jpg",
                        "ratingValue": 88,
                        "disclaimer": true,
                        "description": {
                            "type": "list",
                            "list": [
                                {
                                    "title": "Processor",
                                    "text": " 12th Generation Intel Core i5-12450H Up To 4.40GHz"
                                },
                                {
                                    "title": "Screen Size",
                                    "text": "40CM FHD (1920x1080), 144Hz, 45% NTSC, IPS-Level Panel"
                                },
                                {
                                    "title": "Memory and Storage",
                                    "text": " 8GBx2 DDR5 Dual Channel RAM | Storage: 512GB NVMe PCIe Gen4x4 SSD"
                                },
                                {
                                    "title": "Operating System",
                                    "text": "Pre-loaded Windows 11 Home with lifetime validity | NVIDIA GeForce RTX 4050, GDDR6 6GB "
                                }
                            ],
                            "paragraphs": []
                        }
                    },
                    {
                        "name": "Dell {Smartchoice} G15-5530",
                        "price": "78,990 Rs",
                        "targetUrl": "https://amzn.to/3WQvJXE",
                        "imgSrc": "https://m.media-amazon.com/images/I/61LOOMpEgxL._SX679_.jpg",
                        "ratingValue": 85,
                        "disclaimer": true,
                        "description": {
                            "type": "list",
                            "list": [
                                {
                                    "title": "Processor",
                                    "text": "13th Generation Intel Core i5-13450HX (up to 4.60 GHz, 10 Cores, 20MB); RAM & Storage: 16 GB: 2 x 8 GB, DDR5, 4800 MT/s & 1TB SSD"
                                },
                                {
                                    "title": "Screen Size",
                                    "text": "15.6” FHD Narrow 120Hz 250 nits"
                                },
                                {
                                    "title": "Memory and Storage",
                                    "text": "16GB RAM|1TB SSD"
                                },
                                {
                                    "title": "Operating System",
                                    "text": "Window 11|MS Office' 21 | NVIDIA GeForce RTX 3050, 6GB GDDR6 & 15.6” FHD Narrow 120Hz 250 nits"
                                }
                            ],
                            "paragraphs": []
                        }
                    }
                ]
            }
        ]
    },
    tvUnder30: {
        "title": "Top TV under 30k",
        "subTitle": "",
        "image": "/assets/img/thumbnails/tv-1.png",
        "url": "/top-tvs-under-30k",
        "date": "",
        "tags": [
            "TV",
            "Andriod",
            "HD"
        ],
        "categories": [
            "Technology",
            "Electronics"
        ],
        "recommendations": "TV recommendations",
        "pageStructure": [
            {
                "component": "paragraphBoldItalic",
                "text": "We hope you likes the products we recommend! All of them were independently hand picked by our editors. Just so you know, TopMoneySaver may collect a share of sales or other compensation from the links on this page if you decide to shop from them."
            },
            {
                "component": "productList",
                "list": [
                    {
                        "name": "Xiaomi 108 cm (43 inches) A Pro 4K Dolby Vision Smart Google TV L43MA-AUIN (Black)",
                        "price": "24,999Rs",
                        "targetUrl": "https://amzn.to/3Q5RgI3",
                        "imgSrc": "https://m.media-amazon.com/images/I/71HI+VF6ZXL._SX679_.jpg",
                        "ratingValue": 100,
                        "disclaimer": true,
                        "description": {
                            "type": "",
                            "list": [
                                {
                                    "title": "",
                                    "text": ""
                                }
                            ],
                            "paragraphs": [
                                "Screen Size:43 Inches",
                                "Resolution:4K",
                                "Refresh Rate : 60 Hertz",
                                "Connectivity: Dual Band Wi-Fi | 3 HDMI ports to connect latest gaming consoles, set top box, Blu-ray Players",
                                "Sound: 30 Watts Output | Dolby Audio | DTS-X | DTS Virtual: X",
                                "Display: 4K HDR | Dolby Vision |HDR10 | HLG | Reality Flow MEMC | Vivid Picture Engine| ALLM",
                                "Warranty Information: 1 year comprehensive warranty on product and 1 year additional on Panel provided by the brand from the date of purchase."
                            ]
                        }
                    },
                    {
                        "name": "Acer 109 cm (43 inches) I Pro Series Full HD Smart LED Google TV with Android 14 (Black) | 16GB Storage | 30W Dolby Audio",
                        "price": "18,999Rs",
                        "targetUrl": "https://amzn.to/3CANQdp",
                        "imgSrc": "https://m.media-amazon.com/images/I/71z6h0pIzyL._SX679_.jpg",
                        "ratingValue": 100,
                        "disclaimer": true,
                        "description": {
                            "type": "",
                            "list": [
                                {
                                    "title": "",
                                    "text": ""
                                }
                            ],
                            "paragraphs": [
                                "Resolution : Full HD (1920 x 1080)",
                                "Refresh Rate : 60 Hertz | 178 Degree wide viewing angle",
                                "Connectivity: Dual band Wifi | Bluetooth 5.0 | AV, RF, Ethernet, headphone×1",
                                "USB 2.0x1 to connect hard drives or other USB device",
                                "Sound: 30 Watts Output | High Fidelity Speakers with Dolby Audio | 5 Sound Modes - Standard, Speech, Music, Stadium, User",
                                "ECO mode | Video calling- Google Meeting and TrueConference | Gamepad",
                                "Display: FHD | HDR10 | IFSC",
                            ]
                        }
                    },
                    {
                        "name": "Redmi 108 cm (43 inches) 4K Ultra HD Android Smart LED TV X43 | L43R7-7AIN (Black)",
                        "price": "24,999Rs",
                        "targetUrl": "https://amzn.to/3Tro5iy",
                        "imgSrc": "https://m.media-amazon.com/images/I/41aCNrgZ9eL._SY300_SX300_QL70_FMwebp_.jpg",
                        "ratingValue": 100,
                        "disclaimer": true,
                        "description": {
                            "type": "",
                            "list": [
                                {
                                    "title": "",
                                    "text": ""
                                }
                            ],
                            "paragraphs": [
                                "Resolution : 4K Ultra HD (3840x2160) Resolution",
                                "Refresh Rate : 60 Hertz |178 Degree wide viewing angle",
                                "Connectivity: Dual-band Wi-Fi | Bluetooth 5.0 | 3 HDMI ports to connect latest gaming consoles, set top box, Blu-ray Players | 2 USB ports to connect hard drives",
                                "Smart TV Features : Android TV 10, PatchWall 4 with IMDb integration | Quad core processor, Built-in Wi-Fi, Chromecast built-in, Ok Google, Auto Low Latency Mode, 2GB RAM + 16GB Storage, Miracast",
                                "Supported Apps: Prime Video, Netflix, Disney + Hotstar, YouTube, Apple TV, 5000+ apps from Play Store.",
                                "Display: 4K LED Panel | Dolby Vision | HDR10 | HLG | Reality Flow | Vivid Picture Engine | MEMC",
                                "Warranty Information: 1 year comprehensive warranty on product and 1 year additional on Panel provided by the brand from the date of purchase."
                            ]
                        }
                    },
                    {
                        "name": "Hisense 108 cm (43 inches) E68N Series 4K Ultra HD Smart Google QLED TV 43E68N (Grey)",
                        "price": "26,999Rs",
                        "targetUrl": "https://amzn.to/411juds",
                        "imgSrc": "https://m.media-amazon.com/images/I/71Iujz1y4PL._SX679_.jpg",
                        "ratingValue": 90,
                        "disclaimer": true,
                        "description": {
                            "type": "",
                            "list": [
                                {
                                    "title": "",
                                    "text": ""
                                }
                            ],
                            "paragraphs": [
                                "Display Technology	QLED",
                                "Resolution	4K",
                                "Refresh Rate:60 Hz",
                                "Special Feature:QLED | Dolby Vision | 120 High Refresh Rate | 4K AI Upscaler | Direct Full Array | Pixel Tuning | Depth Enhancer | Game Mode Plus | AI Sports Mode | Filmmaker Mode | Far Field Voice Control | VRR and ALLM | MEMC | HLG",
                                "Connectivity:Bluetooth, Wi-Fi, USB, Ethernet, HDMI",
                                "Sound:24W Speakers Output | Dolby Atoms",
                                "Warranty Information: 1 Year Comprehensive Warranty on product and 1 Year additional warranty on panel for malfunction arising from manufacturing defects."
                            ]
                        }
                    },
                    {
                        "name": "TOSHIBA 108 cm (43 inches) V Series Full HD Smart Android LED TV 43V35MP (Black)",
                        "price": "20,999",
                        "targetUrl": "https://amzn.to/3D247FK",
                        "imgSrc": "https://m.media-amazon.com/images/I/81zHdDIN1vL._SX679_.jpg",
                        "ratingValue": 90,
                        "disclaimer": true,
                        "description": {
                            "type": "",
                            "list": [
                                {
                                    "title": "",
                                    "text": ""
                                }
                            ],
                            "paragraphs": [
                                "Resolution: Resolution	1080p",
                                "Refresh Rate:60 Hz",
                                "Special Features:Official Android TV 11(R) | Built-in Assistant | RAM: 1GB | ROM 8 GB | Quad Core Processor | Supported Apps : Netflix, Prime Video, Disney+ Hotstar etc on Official Play Store",
                                "Connectivity: Connectivity Technology	Wi-Fi, USB, Ethernet, HDMI",
                                "Sound output: Inbuilt 20 Watts Powerful Speakers | Dolby Audio and DTS Tru Surround",
                                "Warranty Information: 1 Year Comprehensive Warranty on product and 1 Year additional warranty on panel for malfunction arising from manufacturing defects."
                            ]
                        }
                    }
                ]
            }
        ]
    },
    tvUnder50: {
        "title": "Top TV under 50k",
        "subTitle": "",
        "image": "/assets/img/thumbnails/tv-1.png",
        "url": "/top-tvs-under-50k",
        "date": "",
        "tags": [
            "TV",
            "4K",
            "Android",
            "50 Inches"
        ],
        "categories": [
            "Technology",
            "Electronics"
        ],
        "recommendations": "TV recommendations",
        "pageStructure": [
            {
                "component": "paragraphBoldItalic",
                "text": "We hope you likes the products we recommend! All of them were independently hand picked by our editors. Just so you know, TopMoneySaver may collect a share of sales or other compensation from the links on this page if you decide to shop from them."
            },
            {
                "component": "productList",
                "list": [
                    {
                        "name": "Acer 139 cm (55 inches) Super Series 4K Ultra HD Smart QLED Google TV with Android 14 (Black)",
                        "price": "₹37,999",
                        "targetUrl": "https://amzn.to/4aO6Xxd",
                        "imgSrc": "https://m.media-amazon.com/images/I/712MJI-diwL._SX679_.jpg",
                        "ratingValue": 100,
                        "disclaimer": true,
                        "description": {
                            "type": "",
                            "list": [
                                {
                                    "title": "",
                                    "text": ""
                                }
                            ],
                            "paragraphs":
                                [
                                    "Display Technology:QLED",
                                    "Resolution:4K",
                                    "Refresh Rate:60 Hz",
                                    "connectivity Technology:Buetooth, Wi-Fi, USB, HDMI",
                                    "Product Dimensions	:11.3D x 123.5W x 71.4H Centimeters",

                                ]
                        }
                    },
                    {
                        "name": "Samsung 138 cm (55 inches) D Series Crystal 4K Vivid Pro Ultra HD Smart LED TV UA55DUE77AKLXL (Black)",
                        "price": "46,999Rs",
                        "targetUrl": "https://amzn.to/3Q3UEDc",
                        "imgSrc": "https://m.media-amazon.com/images/I/81OmhFfS-hL._SL1500_.jpg",
                        "ratingValue": 100,
                        "disclaimer": true,
                        "description": {
                            "type": "",
                            "list": [
                                {
                                    "title": "",
                                    "text": ""
                                }
                            ],
                            "paragraphs": [
                                "Resolution: 4K",
                                "Special Feature:crystal Processor 4K | 4K Upscaling | UHD Dimming | Motion Xcelerator",
                                "Included Components:1 Unit TV, 1 Remote Control, 1 User Manual, 1 Power Cable, 2 Table Stand Base",
                                "Connectivity Technology:Wi-Fi, USB, Ethernet, HDMI",
                            ]
                        }
                    },
                    {
                        "name": "Sony BRAVIA 2 Series 108 cm (43 inches) 4K Ultra HD Smart LED Google TV K-43S25 (Black)",
                        "price": "44000Rs",
                        "targetUrl": "https://amzn.to/3Q7yhgu",
                        "imgSrc": "https://m.media-amazon.com/images/I/81tVUMhHjeL._SX679_.jpg",
                        "ratingValue": 100,
                        "disclaimer": true,
                        "description": {
                            "type": "",
                            "list": [
                                {
                                    "title": "",
                                    "text": ""
                                }
                            ],
                            "paragraphs": [
                                "Screen Size:43 Inches",
                                "connectivity Technology:Wi-Fi, USB, Ethernet, HDMI",
                                "Refresh Rate:60 Hz",
                                "Resolution:4K",
                                "Product Dimensions:7.7D x 97.1W x 57.5H Centimeters",
                                "Display : 4K LED | 4K Processor X1 | Live Color | 4K X-Reality PRO | MotionFlow XR 200 | HDR10/HLG"
                            ]
                        }
                    },
                    {
                        "name": "LG 139 cm (55 inches) 4K Ultra HD Smart LED TV 55UR7500PSC (Dark Iron Gray)",
                        "price": "43,990Rs",
                        "targetUrl": "https://amzn.to/4hIcSWO",
                        "imgSrc": "https://m.media-amazon.com/images/I/71ydzmWXW0L._SL1500_.jpg",
                        "ratingValue": 100,
                        "disclaimer": true,
                        "description": {
                            "type": "",
                            "list": [
                                {
                                    "title": "",
                                    "text": ""
                                }
                            ],
                            "paragraphs": [
                                "Resolution: 4K",
                                "Refresh Rate: 60Hz",
                                "Special Feature: WebOS 23 with User Profiles | Filmmaker Mode, HDR 10 & HLG | Game Optimizer, ALLM, HGIG Mode | Unlimited OTT Apps | AI Brightness Control, 4K Upscaling & AI Sound (Virtual Surround 5.1 up-mix)"
                            ]
                        }
                    },
                    {
                        "name": "Xiaomi 138 cm (55 inches) X Pro 4K Dolby Vision IQ Series Smart Google TV L55M8-5XIN (Black)",
                        "price": "37999 Rs",
                        "targetUrl": "https://amzn.to/4hEPM3X",
                        "imgSrc": "https://m.media-amazon.com/images/I/81DThWoxTuL._SX679_.jpg",
                        "ratingValue": 100,
                        "disclaimer": true,
                        "description": {
                            "type": "",
                            "list": [
                                {
                                    "title": "",
                                    "text": ""
                                }
                            ],
                            "paragraphs": [
                                "Resolution: 4K Ultra HD ",
                                "Refresh Rate:60 Hz",
                                "Special Featres:4K Dolby Vision IQ| Far-field mic | Hey Google | Google TV | HDR10+ | HDR 10 | HLG | Wide Color Gamut | Supported Applications : PatchWall, Netflix, Amazon Prime Video, Disney+ Hotstar, Miracast, Media player, Gallery, TV Manager, User Manual, Live TV, YouTube, YouTube Music, Play Store",

                            ]
                        }
                    }
                ]
            }
        ]
    },
    cameraUnder80: {
        "title": "Top Camera under 80k",
        "subTitle": "",
        "image": "/assets/img/thumbnails/peripheral-1.png",
        "url": "/top-camera-under-80k",
        "date": "",
        "tags": [
            "Camera",
            "DSLR"
        ],
        "categories": [
            "Technology",
            "Electronics"
        ],
        "recommendations": "Camera recommendations",
        "pageStructure": [
            {
                "component": "paragraphBoldItalic",
                "text": "We hope you likes the products we recommend! All of them were independently hand picked by our editors. Just so you know, TopMoneySaver may collect a share of sales or other compensation from the links on this page if you decide to shop from them."
            },
            {
                "component": "productList",
                "list": [
                    {
                        "name": "Nikon Z50 Mirrorless Camera Body with Z DX 16-50mm f/3.5-6.3 VR Lens",
                        "price": "72,599Rs",
                        "targetUrl": "https://amzn.to/4hFC6Fu",
                        "imgSrc": "https://m.media-amazon.com/images/I/61cBZ5Z+ekL._SX679_.jpg",
                        "ratingValue": 95,
                        "disclaimer": true,
                        "description": {
                            "type": "list",
                            "list": [
                                {
                                    "title": "Brand",
                                    "text": "Nikon"
                                },
                                {
                                    "title": "Model Name",
                                    "text": "Mirrorless"
                                },
                                {
                                    "title": "Form Factor",
                                    "text": "Compact, Mirrorless"
                                },
                                {
                                    "title": "Effective Still Resolution",
                                    "text": "20 MP"
                                },
                                {
                                    "title": "Special Feature",
                                    "text": "time lapse"
                                },
                                {
                                    "title": "Optical Zoom",
                                    "text": "3 x"
                                },
                                {
                                    "title": "Color",
                                    "text": "Black"
                                },
                                {
                                    "title": "Connector Type",
                                    "text": "HDMI"
                                },
                                {
                                    "title": "Screen Size",
                                    "text": "3.2 Inches"
                                },
                                {
                                    "title": "Photo Sensor Size",
                                    "text": "Full Frame (35mm)"
                                }
                            ],
                            "paragraphs": []
                        }
                    },
                    {
                        "name": "Sony Alpha ZV-E10L",
                        "price": "61,490Rs",
                        "targetUrl": "https://amzn.to/4ht3k22",
                        "imgSrc": "https://m.media-amazon.com/images/I/71u7HJItZoL._SX679_.jpg",
                        "ratingValue": 93,
                        "disclaimer": true,
                        "description": {
                            "type": "list",
                            "list": [
                                {
                                    "title": "Brand",
                                    "text": "Sony"
                                },
                                {
                                    "title": "Model Name",
                                    "text": "ZV-E10L"
                                },
                                {
                                    "title": "Form Factor",
                                    "text": "Compact, Mirrorless"
                                },
                                {
                                    "title": "Effective Still Resolution",
                                    "text": "24.2MP"
                                },
                                {
                                    "title": "Special Feature",
                                    "text": "4k recording, Live Streaming"
                                },
                                {
                                    "title": "Optical Zoom",
                                    "text": "3 x"
                                },
                                {
                                    "title": "Color",
                                    "text": "Black"
                                },
                                {
                                    "title": "Connector Type",
                                    "text": "HDMI Micro Jack, USB Type-C"
                                },
                                {
                                    "title": "Screen Size",
                                    "text": "3 Inches"
                                },
                                {
                                    "title": "Photo Sensor Size",
                                    "text": "28 Exmor CMOS sensor"
                                }
                            ],
                            "paragraphs": []
                        }
                    },
                    {
                        "name": "Canon EOS R10",
                        "price": "76,990Rs",
                        "targetUrl": "https://amzn.to/4aR6OZM",
                        "imgSrc": "https://m.media-amazon.com/images/I/61o404RqgdL._SX679_.jpg",
                        "ratingValue": 90,
                        "disclaimer": true,
                        "description": {
                            "type": "list",
                            "list": [
                                {
                                    "title": "Brand",
                                    "text": "Canon"
                                },
                                {
                                    "title": "Model Name",
                                    "text": "Canon EOS R10"
                                },
                                {
                                    "title": "Form Factor",
                                    "text": "Mirrorless"
                                },
                                {
                                    "title": "Effective Still Resolution",
                                    "text": "24.2 MP"
                                },
                                {
                                    "title": "Special Feature",
                                    "text": "APS-C Sensor, 23 FPS, Next Gen Auto Focus, Next Level Image Stabilisation, 4K"
                                },
                                {
                                    "title": "Color",
                                    "text": "Black"
                                },
                                {
                                    "title": "Connector Type",
                                    "text": "HDMI"
                                },
                                {
                                    "title": "Screen Size",
                                    "text": "3 Inches"
                                },
                                {
                                    "title": "Shooting Modes",
                                    "text": "High speed shooting 15fps mechanical(3,4), 23fps electronic shutter(4,5) and RAW Burst Mode with ½ second preshooting"
                                }
                            ],
                            "paragraphs": []
                        }
                    },
                    {
                        "name": "Kodak PIXPRO Astro Zoom AZ401-BK 16MP Digital Camera with 40X Optical Zoom and 3Inche LCD (Black)",
                        "price": "32,259Rs",
                        "targetUrl": "https://amzn.to/3QayrUf",
                        "imgSrc": "https://m.media-amazon.com/images/I/61McUe4dmsL._SX679_.jpg",
                        "ratingValue": 80,
                        "disclaimer": true,
                        "description": {
                            "type": "list",
                            "list": [
                                {
                                    "title": "Brand",
                                    "text": "KODAK"
                                },
                                {
                                    "title": "Model Name",
                                    "text": "Kodak AZ401BK"
                                },
                                {
                                    "title": "Form Factor",
                                    "text": "Point and Shoot"
                                },
                                {
                                    "title": "Effective Still Resolution",
                                    "text": "16 MP"
                                },
                                {
                                    "title": "Special Feature",
                                    "text": "Built-In Flash; Optical Image Stabilization; 180° Panorama Mode"
                                },
                                {
                                    "title": "Optical Zoom",
                                    "text": "40 x"
                                },
                                {
                                    "title": "Color",
                                    "text": "Black"
                                },
                                {
                                    "title": "Connector Type",
                                    "text": "USB"
                                },
                                {
                                    "title": "Screen Size",
                                    "text": "3 Inches"
                                },
                                {
                                    "title": "Shooting Modes",
                                    "text": "Panorama"
                                }
                            ],
                            "paragraphs": []
                        }
                    },
                    {
                        "name": "Panasonic LUMIX G7",
                        "price": "42,489Rs",
                        "targetUrl": "https://amzn.to/3WRizdc",
                        "imgSrc": "https://m.media-amazon.com/images/I/91xnO7qHAeL._SX679_.jpg",
                        "ratingValue": 90,
                        "disclaimer": true,
                        "description": {
                            "type": "list",
                            "list": [
                                {
                                    "title": "Brand",
                                    "text": "Panasonic"
                                },
                                {
                                    "title": "Model Name",
                                    "text": "LUMIX G7"
                                },
                                {
                                    "title": "Form Factor",
                                    "text": "Mirrorless"
                                },
                                {
                                    "title": "Effective Still Resolution",
                                    "text": "16MP"
                                },
                                {
                                    "title": "Special Feature",
                                    "text": "4K PHOTO And VIDEO MODE"
                                },
                                {
                                    "title": "Optical Zoom",
                                    "text": "3 x"
                                },
                                {
                                    "title": "Color",
                                    "text": "Black"
                                },
                                {
                                    "title": "Connector Type",
                                    "text": "Wi-Fi"
                                },
                                {
                                    "title": "Screen Size",
                                    "text": "3 Inches"
                                }
                            ],
                            "paragraphs": []
                        }
                    }
                ]
            }
        ]
    },
    bluetoothEarphonesUnder2k: {
        "title": "Top bluetooth earphones under 2k",
        "subTitle": "",
        "image": "/assets/img/thumbnails/earphones-1.png",
        "url": "/top-bluetooth-earphones-under-2k",
        "date": "",
        "tags": [
            "Bluetooth",
            "Earphones"
        ],
        "categories": [
            "Technology",
            "Electronics"
        ],
        "recommendations": "Bluetooth earphone recommendations",
        "pageStructure": [
            {
                "component": "paragraphBoldItalic",
                "text": "We hope you likes the products we recommend! All of them were independently hand picked by our editors. Just so you know, TopMoneySaver may collect a share of sales or other compensation from the links on this page if you decide to shop from them."
            },
            {
                "component": "productList",
                "list": [
{
                        "name": "Boult Audio Z40 True Wireless in Ear Earbuds",
                        "price": "1,199Rs",
                        "targetUrl": "https://amzn.to/4hryh6J",
                        "imgSrc": "https://m.media-amazon.com/images/I/81r4-kfrAvL._SX679_.jpg",
                        "ratingValue": 95,
                        "disclaimer": true,
                        "description": {
                            "type": "",
                            "list": [
                                {
                                    "title": "",
                                    "text": ""
                                }
                            ],
                            "paragraphs": [
                                "Brand : Boult",
                                "Model Name : Audio Z40",
                                "Colour : White",
                                "Form Factor : In Ear",
                                "Connectivity technologies : Wireless",
                                "10mm BoomX tech drivers deliver deep and dynamic bass",
                                "60 hours of total playtime | Type-C Charging",
                                "Fast Charging Supported - 10 mins charge = 100 mins playtime",
                                "Zen Mode – The Environmental Noise Cancellation mode wards off unwanted noise, making your calls crystal clear.",
                                "AI ENC Noise Cancellation",
                                "Bluetooth version: 5.3 | Wireless range - 10 m",
                                "IPX5 Water Resistant | Super Low Latency Gaming Mode"
                            ]
                        }
                    },
                    {
                        "name": "OnePlus Nord Buds 3 Truly Wireless Bluetooth in Ear Earbuds",
                        "price": "1,999Rs",
                        "targetUrl": "https://amzn.to/4gxt6Bb",
                        "imgSrc": "https://m.media-amazon.com/images/I/51CfKYzmFsL._SX679_.jpg",
                        "ratingValue": 92,
                        "disclaimer": true,
                        "description": {
                            "type": "",
                            "list": [
                                {
                                    "title": "",
                                    "text": ""
                                }
                            ],
                            "paragraphs": [
                                "Brand : OnePlus",
                                "Model Name : Nord Buds 3",
                                "Colour : Harmonic Gray",
                                "Form Factor : In Ear",
                                "Connectivity technologies : Wireless",
                                "The buds comes with 12.4 mm Titanized Diaphragm Drivers with which you can enjoy music with deeper bass and pure clear treble",
                                "With up to 32dB Active Noise Cancellation one can maximize the audio enjoyment of music, allowing an immersive listening experience virtually.",
                                "OnePlus Nord Buds 3 is the world's first TWS to receive TÜV Rheinland Battery Health certification. It guarantees at least 80% of the battery capacity left after 1,000 charging cycles.",
                                "The buds can simultaneously connect to two devices such as Andriod/iOS/Windows smartphone, tablets or computers allowing for quick and seamless device switching.",
                                "It has 10mins of Fast Charging that gives 11 hours of Playback time with total music playback up to 43 hours with ANC Off.",
                                "Playback- It offers a total playtime of up to 43 hours.",
                            ]
                        }
                    },
                    {
                        "name": "realme Buds T310 Truly Wireless",
                        "price": "1,999Rs",
                        "targetUrl": "https://amzn.to/41h2Kz7",
                        "imgSrc": "https://m.media-amazon.com/images/I/61kDfm8FD7L._SX679_.jpg",
                        "ratingValue": 90,
                        "disclaimer": true,
                        "description": {
                            "type": "",
                            "list": [
                                {
                                    "title": "",
                                    "text": ""
                                }
                            ],
                            "paragraphs": [
                                "Brand : realme",
                                "Model Name : Buds T310",
                                "Colour : Black",
                                "Form Factor : In Ear",
                                "Connectivity technologies : Wireless, Bluetooth v5.4",
                                "360° Spatial Audio Effect | 12.4mm Dynamic Bass Drive",
                                "46dB Hybrid Noise Cancellation | 45ms Ultra Low Latency 12.4mm Dynamic Bass Driver 40 Hours Total Playback",
                                "Fast Charge :10 Min of Charge =5Hrs Play Back IP55 Water & Dust Resistant Bluetooth V5.4 Dual Device Connectivity.",
                                "40 Hours Total Playback| Fast Charge :10 Min of Charge =5Hrs Play Back.",
                                "IP55 Water & Dust Resistant."
                            ]
                        }
                    },
                    {
                        "name": "iQOO TWS 1e in-Ear Earbuds",
                        "price": "1,899Rs",
                        "targetUrl": "https://amzn.to/4145NKC",
                        "imgSrc": "https://m.media-amazon.com/images/I/51Lz0YlT7tL._SX679_.jpg",
                        "ratingValue": 85,
                        "disclaimer": true,
                        "description": {
                            "type": "",
                            "list": [
                                {
                                    "title": "",
                                    "text": ""
                                }
                            ],
                            "paragraphs": [
                                "Brand : iQOO",
                                "Model Name : iQOO TWS 1e",
                                "Colour : Flame Yellow",
                                "Form Factor : In Ear",
                                "Connectivity technologies : Wireless",
                                "ANC + AI CALL NOISE CANCELLATION comes with Up to 30dB Intelligent Active Noise Cancellation",
                                "42-HOUR BATTERY LIFE & FAST CHARGING:charge your device for 10 mins & enjoy up to 3 hours of music playback",
                                "MONSTER SOUND : new listening experience with DeepX 3.0 Stereo Sound Effects",
                                "BLUETOOTH 5.3 & DUAL DEVICE CONNECTION : It supports connecting to two electronic devices simultaneously",
                                "88ms LOW GAMING LATENCY :It helps deliver faster and more stable gaming experiences with a gaming latency as low as 88ms."
                            ]
                        }
                    },
                    {
                        "name": "Noise Buds VS104",
                        "price": "1,099Rs",
                        "targetUrl": "https://amzn.to/4gxQ62I",
                        "imgSrc": "https://m.media-amazon.com/images/I/51+e7yrgPpL._SX679_.jpg",
                        "ratingValue": 80,
                        "disclaimer": true,
                        "description": {
                            "type": "",
                            "list": [
                                {
                                    "title": "",
                                    "text": ""
                                }
                            ],
                            "paragraphs": [
                                "Brand : Noise",
                                "Model Name : VS104",
                                "Colour : Mint Green",
                                "Form Factor : In Ear",
                                "Connectivity technologies : Wireless",
                                "Up to 45-hour playtime:- Get set for a day full of music and then some more",
                                "Quad mics with ENC :- Enjoy free-flowing conversation no matter where you are",
                                "Low latency up to 50ms :- Experience no audio lag during your daily gaming sessions",
                                "13mm Driver:- Experience sound that hits the right note every single time via the 13mm speaker driver",
                                "Bluetooth v5.2 | Hyper SyncTM | IPX5 water resistance:- Experience instant, lag-free connections and keep your device protected from splashes"
                            ]
                        }
                    }
                ]
            }
        ]
    },
    bluetoothEarbudsUnder2k: {
        "title": "Top bluetooth earbuds under 2k",
        "subTitle": "",
        "image": "/assets/img/thumbnails/earphones-1.png",
        "url": "/top-bluetooth-earbuds-under-2k",
        "date": "",
        "tags": [
            "Bluetooth",
            "Earbuds"
        ],
        "categories": [
            "Technology",
            "Electronics"
        ],
        "recommendations": "Bluetooth earbud recommendations",
        "pageStructure": [
            {
                "component": "paragraphBoldItalic",
                "text": "We hope you likes the products we recommend! All of them were independently hand picked by our editors. Just so you know, TopMoneySaver may collect a share of sales or other compensation from the links on this page if you decide to shop from them."
            },
            {
                "component": "productList",
                "list": [
                    {
                        "name": "Boult Audio Z40 True Wireless in Ear Earbuds",
                        "price": "1,199Rs",
                        "targetUrl": "https://amzn.to/4hryh6J",
                        "imgSrc": "https://m.media-amazon.com/images/I/81r4-kfrAvL._SX679_.jpg",
                        "ratingValue": 95,
                        "disclaimer": true,
                        "description": {
                            "type": "",
                            "list": [
                                {
                                    "title": "",
                                    "text": ""
                                }
                            ],
                            "paragraphs": [
                                "Brand : Boult",
                                "Model Name : Audio Z40",
                                "Colour : White",
                                "Form Factor : In Ear",
                                "Connectivity technologies : Wireless",
                                "10mm BoomX tech drivers deliver deep and dynamic bass",
                                "60 hours of total playtime | Type-C Charging",
                                "Fast Charging Supported - 10 mins charge = 100 mins playtime",
                                "Zen Mode – The Environmental Noise Cancellation mode wards off unwanted noise, making your calls crystal clear.",
                                "AI ENC Noise Cancellation",
                                "Bluetooth version: 5.3 | Wireless range - 10 m",
                                "IPX5 Water Resistant | Super Low Latency Gaming Mode"
                            ]
                        }
                    },
                    {
                        "name": "OnePlus Nord Buds 3 Truly Wireless Bluetooth in Ear Earbuds",
                        "price": "1,999Rs",
                        "targetUrl": "https://amzn.to/4gxt6Bb",
                        "imgSrc": "https://m.media-amazon.com/images/I/51CfKYzmFsL._SX679_.jpg",
                        "ratingValue": 92,
                        "disclaimer": true,
                        "description": {
                            "type": "",
                            "list": [
                                {
                                    "title": "",
                                    "text": ""
                                }
                            ],
                            "paragraphs": [
                                "Brand : OnePlus",
                                "Model Name : Nord Buds 3",
                                "Colour : Harmonic Gray",
                                "Form Factor : In Ear",
                                "Connectivity technologies : Wireless",
                                "The buds comes with 12.4 mm Titanized Diaphragm Drivers with which you can enjoy music with deeper bass and pure clear treble",
                                "With up to 32dB Active Noise Cancellation one can maximize the audio enjoyment of music, allowing an immersive listening experience virtually.",
                                "OnePlus Nord Buds 3 is the world's first TWS to receive TÜV Rheinland Battery Health certification. It guarantees at least 80% of the battery capacity left after 1,000 charging cycles.",
                                "The buds can simultaneously connect to two devices such as Andriod/iOS/Windows smartphone, tablets or computers allowing for quick and seamless device switching.",
                                "It has 10mins of Fast Charging that gives 11 hours of Playback time with total music playback up to 43 hours with ANC Off.",
                                "Playback- It offers a total playtime of up to 43 hours.",
                            ]
                        }
                    },
                    {
                        "name": "realme Buds T310 Truly Wireless",
                        "price": "1,999Rs",
                        "targetUrl": "https://amzn.to/41h2Kz7",
                        "imgSrc": "https://m.media-amazon.com/images/I/61kDfm8FD7L._SX679_.jpg",
                        "ratingValue": 90,
                        "disclaimer": true,
                        "description": {
                            "type": "",
                            "list": [
                                {
                                    "title": "",
                                    "text": ""
                                }
                            ],
                            "paragraphs": [
                                "Brand : realme",
                                "Model Name : Buds T310",
                                "Colour : Black",
                                "Form Factor : In Ear",
                                "Connectivity technologies : Wireless, Bluetooth v5.4",
                                "360° Spatial Audio Effect | 12.4mm Dynamic Bass Drive",
                                "46dB Hybrid Noise Cancellation | 45ms Ultra Low Latency 12.4mm Dynamic Bass Driver 40 Hours Total Playback",
                                "Fast Charge :10 Min of Charge =5Hrs Play Back IP55 Water & Dust Resistant Bluetooth V5.4 Dual Device Connectivity.",
                                "40 Hours Total Playback| Fast Charge :10 Min of Charge =5Hrs Play Back.",
                                "IP55 Water & Dust Resistant."
                            ]
                        }
                    },
                    {
                        "name": "iQOO TWS 1e in-Ear Earbuds",
                        "price": "1,899Rs",
                        "targetUrl": "https://amzn.to/4145NKC",
                        "imgSrc": "https://m.media-amazon.com/images/I/51Lz0YlT7tL._SX679_.jpg",
                        "ratingValue": 85,
                        "disclaimer": true,
                        "description": {
                            "type": "",
                            "list": [
                                {
                                    "title": "",
                                    "text": ""
                                }
                            ],
                            "paragraphs": [
                                "Brand : iQOO",
                                "Model Name : iQOO TWS 1e",
                                "Colour : Flame Yellow",
                                "Form Factor : In Ear",
                                "Connectivity technologies : Wireless",
                                "ANC + AI CALL NOISE CANCELLATION comes with Up to 30dB Intelligent Active Noise Cancellation",
                                "42-HOUR BATTERY LIFE & FAST CHARGING:charge your device for 10 mins & enjoy up to 3 hours of music playback",
                                "MONSTER SOUND : new listening experience with DeepX 3.0 Stereo Sound Effects",
                                "BLUETOOTH 5.3 & DUAL DEVICE CONNECTION : It supports connecting to two electronic devices simultaneously",
                                "88ms LOW GAMING LATENCY :It helps deliver faster and more stable gaming experiences with a gaming latency as low as 88ms."
                            ]
                        }
                    },
                    {
                        "name": "Noise Buds VS104",
                        "price": "1,099Rs",
                        "targetUrl": "https://amzn.to/4gxQ62I",
                        "imgSrc": "https://m.media-amazon.com/images/I/51+e7yrgPpL._SX679_.jpg",
                        "ratingValue": 80,
                        "disclaimer": true,
                        "description": {
                            "type": "",
                            "list": [
                                {
                                    "title": "",
                                    "text": ""
                                }
                            ],
                            "paragraphs": [
                                "Brand : Noise",
                                "Model Name : VS104",
                                "Colour : Mint Green",
                                "Form Factor : In Ear",
                                "Connectivity technologies : Wireless",
                                "Up to 45-hour playtime:- Get set for a day full of music and then some more",
                                "Quad mics with ENC :- Enjoy free-flowing conversation no matter where you are",
                                "Low latency up to 50ms :- Experience no audio lag during your daily gaming sessions",
                                "13mm Driver:- Experience sound that hits the right note every single time via the 13mm speaker driver",
                                "Bluetooth v5.2 | Hyper SyncTM | IPX5 water resistance:- Experience instant, lag-free connections and keep your device protected from splashes"
                            ]
                        }
                    }
                ]
            }
        ]
    },
    monitorUnder20k: {
        "title": "Top monitor under 20k",
        "subTitle": "",
        "image": "/assets/img/thumbnails/peripheral-1.png",
        "url": "/top-monitor-under-20k",
        "date": "",
        "tags": [
            "Monitor"
        ],
        "categories": [
            "Technology",
            "Electronics"
        ],
        "recommendations": "Monitor recommendations",
        "pageStructure": [
            {
                "component": "paragraphBoldItalic",
                "text": "We hope you likes the products we recommend! All of them were independently hand picked by our editors. Just so you know, TopMoneySaver may collect a share of sales or other compensation from the links on this page if you decide to shop from them."
            },
            {
                "component": "productList",
                "list": [
                    {
                        "name": "Zebronics ZEB-A27FHD Slim Gaming LED Monitor",
                        "price": "9,999Rs",
                        "targetUrl": "https://amzn.to/4aPgyE0",
                        "imgSrc": "https://m.media-amazon.com/images/I/71A-tHr9UsL._SX679_.jpg",
                        "ratingValue": 95,
                        "disclaimer": true,
                        "description": {
                            "type": "list",
                            "list": [
                                {
                                    "title": "Screen Size",
                                    "text": "68.5 Centimetres"
                                },
                                {
                                    "title": "Display Resolution Maximum",
                                    "text": "1920 X 1080 (FHD) Pixels"
                                },
                                {
                                    "title": "Brand",
                                    "text": "ZEBRONICS"
                                },
                                {
                                    "title": "Special Feature",
                                    "text": "Built In Speakers"
                                },
                                {
                                    "title": "Design",
                                    "text": "Slim Design, Ultra Slim Bezel"
                                },
                                {
                                    "title": "Refresh Rate",
                                    "text": "165 Hz"
                                }
                            ],
                            "paragraphs": []
                        }
                    },
                    {
                        "name": "Dell 24 inch P2425H Monitor",
                        "price": "14,499Rs",
                        "targetUrl": "https://amzn.to/41aGaXF",
                        "imgSrc": "https://m.media-amazon.com/images/I/81r4H4+w+FL._SX679_.jpg",
                        "ratingValue": 95,
                        "disclaimer": true,
                        "description": {
                            "type": "list",
                            "list": [
                                {
                                    "title": "Screen Size",
                                    "text": "60.452 Centimetres"
                                },
                                {
                                    "title": "Display Resolution Maximum",
                                    "text": "IPS FHD with 1920 x 1080 Pixels"
                                },
                                {
                                    "title": "Brand",
                                    "text": "Dell"
                                },
                                {
                                    "title": "Special Feature",
                                    "text": "Height Adjustment, Anti Glare Screen, Blue Light Filter, Swivel Adjustment, USB-C Downstream, Flicker-Free"
                                },
                                {
                                    "title": "Design",
                                    "text": "Slim Design, Ultra Slim Bezel"
                                },
                                {
                                    "title": "Refresh Rate",
                                    "text": "100 Hz"
                                }
                            ],
                            "paragraphs": []
                        }
                    },
                    {
                        "name": "Acer Nitro Vg271U M3 Monitor",
                        "price": "14,998Rs",
                        "targetUrl": "https://amzn.to/3WSHuNl",
                        "imgSrc": "https://m.media-amazon.com/images/I/71s8OHQKciL._SX679_.jpg",
                        "ratingValue": 90,
                        "disclaimer": true,
                        "description": {
                            "type": "list",
                            "list": [
                                {
                                    "title": "Screen Size",
                                    "text": "68.58 Centimetres"
                                },
                                {
                                    "title": "Display Resolution Maximum",
                                    "text": "2560 x 1440 QHD Wide 1440 Pixels"
                                },
                                {
                                    "title": "Brand",
                                    "text": "Acer"
                                },
                                {
                                    "title": "Special Feature",
                                    "text": "Integrated AMD FreeSync technology, Blue Light Filter"
                                },
                                {
                                    "title": "Design",
                                    "text": "Slim Design, Ultra Slim Bezel"
                                },
                                {
                                    "title": "Refresh Rate",
                                    "text": "180Hz"
                                }
                            ],
                            "paragraphs": []
                        }
                    },
                    {
                        "name": "LG 27MS550 Full HD Monitor",
                        "price": "10,999Rs",
                        "targetUrl": "https://amzn.to/3QakbuH",
                        "imgSrc": "https://m.media-amazon.com/images/I/61eeuz4xhZL._SX679_.jpg",
                        "ratingValue": 88,
                        "disclaimer": true,
                        "description": {
                            "type": "list",
                            "list": [
                                {
                                    "title": "Screen Size",
                                    "text": "68.58 Centimetres"
                                },
                                {
                                    "title": "Display Resolution Maximum",
                                    "text": "1920 X 1080 (FHD) Pixels"
                                },
                                {
                                    "title": "Brand",
                                    "text": "LG"
                                },
                                {
                                    "title": "Special Feature",
                                    "text": "Anti Glare Screen, Adaptive Sync, Tilt Adjustment, Flicker-Free, Reader Mode,OnScreen Control"
                                },
                                {
                                    "title": "Refresh Rate",
                                    "text": "100 Hz"
                                }
                            ],
                            "paragraphs": []
                        }
                    },
                    {
                        "name": "Samsung LS27C330GAWXXL 22 inch Full HD Monitor",
                        "price": "10,090Rs",
                        "targetUrl": "https://amzn.to/3WNH3UE",
                        "imgSrc": "https://m.media-amazon.com/images/I/612Ax0sjR8L._SL1500_.jpg",
                        "ratingValue": 80,
                        "disclaimer": true,
                        "description": {
                            "type": "list",
                            "list": [
                                {
                                    "title": "Screen Size",
                                    "text": "68.59 Centimetres"
                                },
                                {
                                    "title": "Display Resolution Maximum",
                                    "text": "1920 X 1080 (FHD) Pixels"
                                },
                                {
                                    "title": "Brand",
                                    "text": "Samsung"
                                },
                                {
                                    "title": "Design",
                                    "text": "Flat Monitor, Bezel Less"
                                },
                                {
                                    "title": "Special Feature",
                                    "text": "AMD Freesync, Flicker-Free"
                                },
                                {
                                    "title": "Refresh Rate",
                                    "text": "100 Hz"
                                }
                            ],
                            "paragraphs": []
                        }
                    }
                ]
            }
        ]
    },
    mouseUnder1k: {
        "title": "Top wireless mouse under 1k",
        "subTitle": "",
        "image": "/assets/img/thumbnails/peripheral-1.png",
        "url": "/top-mouse-under-30k",
        "date": "",
        "tags": [
            "Wireless"
        ],
        "categories": [
            "Technology",
            "Electronics"
        ],
        "recommendations": "Mouse recommendations",
        "pageStructure": [
            {
                "component": "paragraphBoldItalic",
                "text": "We hope you likes the products we recommend! All of them were independently hand picked by our editors. Just so you know, TopMoneySaver may collect a share of sales or other compensation from the links on this page if you decide to shop from them."
            },
            {
                "component": "productList",
                "list": [
                    {
                        "name": "ZEBRONICS Blanc Slim Wireless Mouse ",
                        "price": "499Rs",
                        "targetUrl": "https://amzn.to/3CIUYnU",
                        "imgSrc": "https://m.media-amazon.com/images/I/51vMo-pHZ5L._SX569_.jpg",
                        "ratingValue": 100,
                        "disclaimer": true,
                        "description": {
                            "type": "",
                            "list": [
                                {
                                    "title": "",
                                    "text": ""
                                }
                            ],
                            "paragraphs": [
                                "Brand : ZEBRONICS",
                                "Color: black",
                                "Connector Type : USB",
                                "Special Feature : Wireless",
                                "Movement Detection Technology : Optical",
                                "Quieter Click : Work in an environment without clicking noises from the mouse as it is well-built with silent operation",
                                "Advanced Optical Tracking :  This quiet computer mouse provides high-performance precision and smart cursor control on most surfaces.",
                                "Plug and Play: Plug the USB mini-receiver into your Windows, Mac, Chrome, OS, or Linux computer and forget about it; you can even add more compatible wireless devices without using multiple USB ports."
                            ]
                        }
                    },
                    {
                        "name": "Portronics Toad One Bluetooth Mouse with 2.4 GHz & BT 5.3 Dual Wireless,",
                        "price": "549Rs",
                        "targetUrl": "https://amzn.to/4aPMXu0",
                        "imgSrc": "https://m.media-amazon.com/images/I/51hZtBRUFBL._SX522_.jpg",
                        "ratingValue": 90,
                        "disclaimer": true,
                        "description": {
                            "type": "",
                            "list": [
                                {
                                    "title": "",
                                    "text": ""
                                }
                            ],
                            "paragraphs": [
                                "Brand : Portronics Toad ",
                                "Color: Black",
                                "Connector Type: USB",
                                "Special Feature : Wireless, Ergonomic Design",
                                "Movement Detection Technology: Optical",
                                "Take out the mouse, insert the USB, and click away. Your connection stays strong with the 2.4 GHz USB receiver. And when you’re done, dock the receiver in the mouse itself.",
                                "[WIRELESS FREEDOM] - Enjoy up to a 10-meter wireless connection with the Toad One wireless mouse’s tiny plug-and-forget nano dongle.",
                                "[ADJUSTABLE DPI RESOLUTION]:This feature gives you more room to enhance your gaming skills and even work on editing with pixel-based simplicity."
                            ]
                        }
                    },
                    {
                        "name": "Dell WM118 Wireless Mouse",
                        "price": "649Rs",
                        "targetUrl": "https://amzn.to/4gwvisw",
                        "imgSrc": "https://m.media-amazon.com/images/I/41rIY4opa3L._SX522_.jpg",
                        "ratingValue": 90,
                        "disclaimer": true,
                        "description": {
                            "type": "",
                            "list": [
                                {
                                    "title": "",
                                    "text": ""
                                }
                            ],
                            "paragraphs": [
                                "Brand : Dell",
                                "Color: Black",
                                "Connector Type: USB",
                                "Special Feature : Wireless, Laser",
                                "Movement Detection Technology: Trackball",
                                "Connector Type : Wireless (USB receiver connects to laptop/desktop).",
                                "Power Source Type: Battery Power.",
                                "Wireless Reception Range : 10 metres",
                                "2.4 Ghz with USB Nano Receiver, Optical Tracking, 12-Months Battery Life"
                            ]
                        }
                    },
                    {
                        "name": "HP S500 7YA11PA USB, Wireless Optical Mouse",
                        "price": "520 Rs",
                        "targetUrl": "https://amzn.to/3CTADMJ",
                        "imgSrc": "https://m.media-amazon.com/images/I/51A1vwtYr+L._SX569_.jpg",
                        "ratingValue": 90,
                        "disclaimer": true,
                        "description": {
                            "type": "",
                            "list": [
                                {
                                    "title": "",
                                    "text": ""
                                }
                            ],
                            "paragraphs": [
                                "Brand : HP",
                                "Color: Black",
                                "Connector Type: USB",
                                "Special Feature : Wireless",
                                "Movement Detection Technology: Optical",
                                "Range: 10 meters",
                                "5 Display settings (text, internet, game, movie and sport) to meet different viewing conditions with hotkey adjustment",
                                "Supports Windows 7 | Windows 8 | Windows 10 | Mac OS 10.3 or Later | Chrome OS",
                                "Hardware Platform: Pc"
                            ]
                        }
                    },
                    {
                        "name": "Lenovo 130 Wireless Compact Mouse,",
                        "price": "658 Rs",
                        "targetUrl": "https://amzn.to/4aYejOQ",
                        "imgSrc": "https://m.media-amazon.com/images/I/21N0SU36xXL.jpg",
                        "ratingValue": 90,
                        "disclaimer": true,
                        "description": {
                            "type": "",
                            "list": [
                                {
                                    "title": "",
                                    "text": ""
                                }
                            ],
                            "paragraphs": [
                                "Brand : lenovo",
                                "Color: Black",
                                "Connector Type: wireless,USB",
                                "Movement Detection Technology:Laser",
                                "Special Feature : Ergonomic Design",
                                "Movement Detection Technology: Optical",
                                "No more distractions: With a 2.4 GHz Nano USB receiver and up to 10 months battery life, your work will never be interrupted again",
                                "Accuracy is everything: Seamlessly glide between tasks with in-built 1000 DPI optical sensor navigation.",
                                "Sensor Technology: Optical Sensor, Sensor Resolution: 1000 DPI, Scroll Wheel: Yes (up/down), Right & Left: Up to 3 Million Clicks, Wireless Technology: 2.4 GHz Wireless via Nano USB, Battery Type : 1 x AA",
                                "The Compact Mouse that's built for You: The Lenovo 130 Wireless Compact Mouse, designed with your convenience in mind."
                            ]
                        }
                    }
                ]
            }
        ]
    },
    pendrive1k: {
        "title": "Top 64GB USB Pendrive under 1k",
        "subTitle": "",
        "image": "/assets/img/thumbnails/peripheral-1.png",
        "url": "/top-pendrive-under-1k",
        "date": "",
        "tags": [
            "USB",
            "Pendrive",
            "Externl Storage"
        ],
        "categories": [
            "Technology",
            "Electronics"
        ],
        "recommendations": "USB Pendrive recommendations",
        "pageStructure": [
            {
                "component": "paragraphBoldItalic",
                "text": "We hope you likes the products we recommend! All of them were independently hand picked by our editors. Just so you know, TopMoneySaver may collect a share of sales or other compensation from the links on this page if you decide to shop from them."
            },
            {
                "component": "productList",
                "list": [
                    {
                        "name": "HP v236w USB 2.0 64GB Pen Drive",
                        "price": "399Rs",
                        "targetUrl": "https://amzn.to/4hoqbvQ",
                        "imgSrc": "https://m.media-amazon.com/images/I/61xNG4wjOuL._SX569_.jpg",
                        "ratingValue": 90,
                        "disclaimer": true,
                        "description": {
                            "type": "",
                            "list": [
                                {
                                    "title": "",
                                    "text": ""
                                }
                            ],
                            "paragraphs": [
                                "Brand : HP",
                                "Memory Storage: 64 GB",
                                "Hardware Interface: USB",
                                "Special Feature : Shock proof,Drop Proof",
                                "Write Speed: 4 Megabytes Per Second",
                                "Pendrive for USB Type-C Smartphones and PC Easily transfer files between smartphones, tablets and computers.",
                                "Free up space on your Android smartphone.",
                                "Two connectors—a USB Type-C connector and a regular USB connector."
                            ]
                        }
                    },
                    {
                        "name": "SanDisk Ultra 64 GB USB 3.0 Pen Drive (SDCZ48-064G-135/SDCZ48-064G-UAM46, Black)",
                        "price": "459Rs",
                        "targetUrl": "https://amzn.to/413ci0g",
                        "imgSrc": "https://m.media-amazon.com/images/I/41dTKMktiSL._SX569_.jpg",
                        "ratingValue": 88,
                        "disclaimer": true,
                        "description": {
                            "type": "",
                            "list": [
                                {
                                    "title": "",
                                    "text": ""
                                }
                            ],
                            "paragraphs": [
                                "Brand : SanDisk",
                                "Memory Storage: 64 GB",
                                "Hardware Interface: USB 3.0",
                                "Special Feature : Water Resistant, Encrypted",
                                "Write Speed: 100 Megabytes Per seconds",
                                "Fast transfer speeds up to 100mbps",
                                "USB 3.0-enabled and USB 2.0-compatible",
                                "5 years limited warranty provided by the manufacturer from the date of purchase"
                            ]
                        }
                    },
                    {
                        "name": "SanDisk Cruzer Blade 64GB USB 2.0 Flash Drive",
                        "price": "389Rs",
                        "targetUrl": "https://amzn.to/4jIZjs2",
                        "imgSrc": "https://m.media-amazon.com/images/I/61mcOyUlsTL._SX569_.jpg",
                        "ratingValue": 100,
                        "disclaimer": true,
                        "description": {
                            "type": "",
                            "list": [
                                {
                                    "title": "",
                                    "text": ""
                                }
                            ],
                            "paragraphs": [
                                "Brand : SanDisk",
                                "Memory Storage: 64 GB",
                                "Hardware Interface: USB 2.0",
                                "Special Feature : Shockproof, Compact, Portable, Encrypted,Drop Proof",
                                "Write Speed: 4x",
                                "Free up space on your OTG-enabled Android phone ; Pen-drive Memory Type- DDR3 SDRAM,care number:9/2",
                                "Operating temperature: 0ºC to 45ºC , Storage temperature: -10ºC to 70ºC",
                                "The models are different because production is from different countries. Otherwise both are sandisk cruzer blade models."
                            ]
                        }
                    },
                    {
                        "name": "SanDisk Ultra Flair 64GB USB 3.0 Pen Drive, Multicolor",
                        "price": "464Rs",
                        "targetUrl": "https://amzn.to/4hoGhFA",
                        "imgSrc": "https://m.media-amazon.com/images/I/51uBDIyAZlL._SX569_.jpg",
                        "ratingValue": 100,
                        "disclaimer": true,
                        "description": {
                            "type": "",
                            "list": [
                                {
                                    "title": "",
                                    "text": ""
                                }
                            ],
                            "paragraphs": [
                                "Brand : SanDisk",
                                "Memory Storage: 64 GB",
                                "Hardware Interface: USB 3.0",
                                "Special Feature : Dureble, Fast Data Transfer, Sleek, Password Protected, Data Encryption, Easy File Recovery,Water Resistant",
                                "Write Speed: 1k",
                                "Compatible with both USB 2.0 and 3.0 ports, Operating temperature32° – 95°F (0° – 35°C)",
                            ]
                        }
                    },
                    {
                        "name": "SanDisk Ultra Dual Drive Go usb3.0 Type C Pendrive for Mobile (Black, 64 GB, 5Y - SDDDC3-064G-I35)",
                        "price": "699Rs",
                        "targetUrl": "https://amzn.to/4hobo4l",
                        "imgSrc": "https://m.media-amazon.com/images/I/617wjUR4vbL._SX569_.jpg",
                        "ratingValue": 84,
                        "disclaimer": true,
                        "description": {
                            "type": "",
                            "list": [
                                {
                                    "title": "",
                                    "text": ""
                                }
                            ],
                            "paragraphs": [
                                "Brand : SanDisk",
                                "Memory Storage : 64 GB",
                                "Hardware Interface : USB 3.0",
                                "Write Speed : 56x",
                                "The 2-in-1 flash drive with a reversible USB Type-C and a traditional Type-A connector.",
                                "Free up space on your USB Type-C smartphone so you can take more photos.",
                                "High-performance USB 3.1 Gen 1 drive with 150MB/s read speeds lets you quickly move your files to your computer."
                            ]
                        }
                    }
                ]
            }
        ]
    },
    smartwatch5k: {
        "title": "Top Smartwatch under 5k",
        "subTitle": "",
        "image": "/assets/img/thumbnails/smart-watches-1.png",
        "url": "/top-smartwatch-under-1k",
        "date": "",
        "tags": [
            "Watch",
            "Smartwatch",
            "Bluetooth watch"
        ],
        "categories": [
            "Technology",
            "Electronics"
        ],
        "recommendations": "Smartwatch recommendations",
        "pageStructure": [
            {
                "component": "paragraphBoldItalic",
                "text": "We hope you likes the products we recommend! All of them were independently hand picked by our editors. Just so you know, TopMoneySaver may collect a share of sales or other compensation from the links on this page if you decide to shop from them."
            },
            {
                "component": "productList",
                "list": [
                    {
                        "name": "Titan Zeal Premium Fashion Smartwatch",
                        "price": "3,999Rs",
                        "targetUrl": "https://amzn.to/3CFccmg",
                        "imgSrc": "https://m.media-amazon.com/images/I/71JZiGISnAL._SX425_.jpg",
                        "ratingValue": 100,
                        "disclaimer": true,
                        "description": {
                            "type": "",
                            "list": [
                                {
                                    "title": "",
                                    "text": ""
                                }
                            ],
                            "paragraphs": [
                                "Brand : Titan Zeal",
                                "Model Name: Visionary",
                                "Style: Modern",
                                "Colour : Black Mesh",
                                "Screen Size: 1.8 Inches",
                                "SingleSync BT Calling with Favourite Contact Storage; 100+ Sports Modes with AI Coach and Auto Multisport Recognition",
                                "Upto 5 Day of Battery Life Under Standard Conditions, 3 Days of Battery Life with BT Calling; Calculator, Calendar, In-Built Games, AI Voice Assistant ",
                                "Closure Type: Hook Buckle; Target Gender: Unisex",
                                "Sport Type: Walking, running, cycling, badminton, basketball"
                            ]
                        }
                    },
                    {
                        "name": "Noise ColorFit Ultra 3 Bluetooth Calling Smart Watch",
                        "price": "2,499Rs",
                        "targetUrl": "https://amzn.to/42T0jny",
                        "imgSrc": "https://m.media-amazon.com/images/I/71Vx928Yx2L._SX522_.jpg",
                        "ratingValue": 100,
                        "disclaimer": true,
                        "description": {
                            "type": "",
                            "list": [
                                {
                                    "title": "",
                                    "text": ""
                                }
                            ],
                            "paragraphs": [
                                "Brand : Noise",
                                "Style: ColorFit Ultra 3 Buzz",
                                "Colour : Jet Black",
                                "Age Range : Youth",
                                "Band Color : Black",
                                "Screen Size: 1.9 Inches",
                                "Item Height 12 Millimeters",
                                "Item Width	‎39 Millimeters",
                                "Special Feature	Activity Tracker, Calorie Tracker, Oxymeter (SpO2), Notifications, Heart Rate Monitor",
                                "Noise Health Suite: Stay in the loop with what’s going with your body via Noise Health Suite.",
                                "About this item:Heart Rate Monitor,Activity Tracker,Calorie Tracker,Oxymeter (SpO2)",
                            ]
                        }
                    },
                    {
                        "name": "Fastrack New Limitless Classic",
                        "price": "2499Rs",
                        "targetUrl": "https://amzn.to/41baSRC",
                        "imgSrc": "https://m.media-amazon.com/images/I/617eGDTJz4L._SX425_.jpg",
                        "ratingValue": 90,
                        "disclaimer": true,
                        "description": {
                            "type": "",
                            "list": [
                                {
                                    "title": "",
                                    "text": ""
                                }
                            ],
                            "paragraphs": [
                                "Brand : Fasttrack",
                                "Color :  Black",
                                "Large 1.91 UltraVU HD Display",
                                "Bluetooth Version V 5.1",
								"Battery Capacity	270",
                                "SingleSync BT Calling with Favourite Contacts storage; Fuel up your passionate sports with 100+ Advanced sports modes",
                                "Extensive Health Monitoring with Auto Stress Monitor, 24x7 Heart Rate, Sleep Tracker, Spo2 and Women's Health",
								"Closure Type: Hook Buckle; Target Gender: Unisex; Sport Type: Walking, running, cycling, badminton, basketball; Warranty Type: 1 Year Manufacturer Warranty",
                            ]
                        }
                    },
                    {
                        "name": "CrossBeats Diva 1.28” Stylish Smart Watch for Women",
                        "price": "3999Rs",
                        "targetUrl": "https://amzn.to/3WZmdS9",
                        "imgSrc": "https://m.media-amazon.com/images/I/715SJSOIX5L._SX425_.jpg",
                        "ratingValue": 100,
                        "disclaimer": true,
                        "description": {
                            "type": "",
                            "list": [
                                {
                                    "title": "",
                                    "text": ""
                                }
                            ],
                            "paragraphs": [
                                "Brand : Crossbeats",
                                "Operating System:IOS, Android",
                                "1.28 Amoled Display: Light up your world with 1.28” (3.25cm) Amoled Display, with max 700 nits of brightness.",
                                "Color : Rose Gold",
                                "Designed for Her Health: The Diva’s advanced biosensor is designed for female health tracking, SP02, BP and heart monitoring.",
                                "Smart Battery Life: With a battery life of 7 days while use,The powerful 200 mah battery allows you to get more done, on the go",
                                "Warranty : Crossbeats Diva Smart watch comes with 12 months Warranty against Manufacturing Defects | ",
                                "Studded with precious stones and a full metal bezel, the Diva is luxury on your wrist"
                            ]
                        }
                    },
                    {
                        "name": "CrossBeats Nexus 2.01” Super AMOLED Display Smart Watch with ChatGPT-Powered",
                        "price": "3,999Rs",
                        "targetUrl": "https://amzn.to/3ELlnC7",
                        "imgSrc": "https://m.media-amazon.com/images/I/71oaPtBkvxL._SX425_.jpg",
                        "ratingValue": 90,
                        "disclaimer": true,
                        "description": {
                            "type": "",
                            "list": [
                                {
                                    "title": "",
                                    "text": ""
                                }
                            ],
                            "paragraphs": [
                                "Brand : Crossbeat Nexus",
                                "Style : Modern",
                                "Color : Black",
                                "Screen Size: 2.01 Inches",
                                "Powered by Chat GPT: Enabled with the power of Open AI, Nexus gives you the ability to do more on your wrist. Powered by an advanced voice recognition system, Chat GPT is one voice command away. ",
                                "Long-Lasting Battery: Equipped with a powerful 250 MAH battery, the Nexus can last up to 6 days on a single charge.",
                                "Special Features:Blood Pressure Monitor, Multisport Tracker, Activity Tracker, Always On Display, Heart Rate Monitor",
                                "Track 60 different sports mode like running, walking, climbing, kabbadi, cricket and many more, get the benefit of every sweat and calorie lost"
                            ]
                        }
                    }
                ]
            }
        ]
    }
};